import React from 'react';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

const AppContainer = styled.div`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1a1a1a;
  background: #fafafa;
`;

function App() {
  return (
    <AppContainer>
      <Navbar />
      <Hero />
      <About />
      <Contact />
      <Footer />
    </AppContainer>
  );
}

export default App;
